export { useIsCustomerAddress } from './useIsCustomerAddress';
